import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { ProductService } from '../services/product.service';

export const productInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.includes('/admin/')) {
    return next(req);
  }

  if (req.url.includes('/admin/auth/login') || req.url.includes('/admin/auth/refresh')) {
    return next(req);
  }

  const productService = inject(ProductService);
  const activeProduct = productService.getActiveProduct();

  if (activeProduct) {
    const cloned = req.clone({
      setHeaders: { 'X-Product-Id': String(activeProduct.id) },
    });
    return next(cloned);
  }

  return next(req);
};
